export const centralEllipsis = (inputString?: string, maxCharsVisible = 10): string => {
  const ellipsisString = '...';

  if (!inputString) {
    return '';
  }

  if (inputString.length < maxCharsVisible) {
    return inputString;
  }

  const ellipsisStartIndex = Math.floor(maxCharsVisible / 2) + 2;
  const ellipsisEndIndex = inputString.length - Math.floor(maxCharsVisible / 2) - 2;

  return `${inputString.slice(0, ellipsisStartIndex)}${ellipsisString}${inputString.slice(ellipsisEndIndex)}`;
};

export const endEllipsis = (inputString: string, maxCharsVisible = 10): string => {
  if (!inputString) {
    return '';
  }

  const regexp = new RegExp(`(.{${maxCharsVisible}})(.*)`);

  return inputString.replace(regexp, (match, visibleGroup) => {
    return `${visibleGroup}...`;
  });
};

export const walletAddressEllipsis = (address?: string, endChars = 14): string => {
  if (!address) {
    return '';
  }

  if (address.length <= 2 + endChars) {
    return address;
  }

  const prefix = address.startsWith('0x') ? '0x' : '';
  const suffix = address.slice(-endChars);

  return `${prefix}...${suffix}`;
};
